export enum AlertThresholds {
    'Less than 1 month' = 30,
    'Less than 2 months' = 60,
    'Less than 3 months' = 90,
    'Less than 6 months' = 180,
    'Less than 12 months' = 360,
    'Less than 18 months' = 540,
    'Less than 24 months' = 720
};